<template>
  <vs-tabs
    v-if="activeVenue"
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab
      icon-pack="feather"
      icon="icon-info"
      :label="!isSmallerScreen ? 'General' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-general />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-info"
      :label="!isSmallerScreen ? 'Contact' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-idam />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-map-pin"
      :label="!isSmallerScreen ? 'Address' : ''"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-address />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-clock"
      :label="!isSmallerScreen ? 'Opening Hours' : ''"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-opening-hours />
      </div>
    </vs-tab>
    <!--
    <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Account' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-account />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notifications' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-notifications />
      </div>
    </vs-tab>
    -->
  </vs-tabs>
</template>

<script>
import VenueGeneral from "./VenueGeneral.vue";
import VenueOpeningHours from "./VenueOpeningHours.vue";
import VenueAddress from "./VenueAddress.vue";
import VenueIdam from "./VenueIdam.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    VenueGeneral,
    VenueIdam,
    VenueAddress,
    VenueOpeningHours,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>